export default __webpack_public_path__ + "static/TIMBERLINE-S-SERIES-20-O-Nav-WEB-88ff7523e50775a57c8108704f53159c.png";